module.exports = __webpack_public_path__ + "static/media/remind_password.5567bc96.png";